import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {environment} from "projects/store/src/environments/environment";
import {DOCUMENT} from "@angular/common";
import {ActivatedRoute, Router, NavigationEnd} from "@angular/router";
import {filter} from "rxjs/operators";
import { SalesWorkflow } from '../../enums';

@Component({
  selector: 'app-app.layout-sales-v2',
  templateUrl: './app.layout-sales-v2.component.html'
})
export class AppLayoutSalesV2Component implements OnInit, AfterViewInit {
  srcLogo = `assets/images/${environment.global.country.code}/krediya-logo.svg`;
  showHeader = false;
  isV3Theme = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {
    // Establecer tema inicial
    this.setThemeByFlowCode();

    // Escuchar cambios de navegación para actualizar el tema
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.setThemeByFlowCode();
    });
  }

  /**
   * Establece el tema CSS según el flow_code de la ruta
   * Si flow_code === 'app-krdya' usa tema V3, sino V2
   */
  private setThemeByFlowCode(): void {
    // Acceder a los parámetros de la ruta hija activa
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }

    const flowCode = route?.snapshot?.params['flow_code'];
    console.log('Flow Code:', flowCode);
    const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;

    this.isV3Theme = flowCode === SalesWorkflow['app-krdya-cliente'] || flowCode === SalesWorkflow['app-krdya-kredicash'];

    if (themeLink) {
      if (this.isV3Theme) {
        themeLink.href = 'krediya.v3-theme.css';
      } else {
        themeLink.href = 'krediya.v2-theme.css';
      }
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.showHeader = true;
    }, 400);
  }
}
